import Web3 from "web3";

export default new Web3(
  Web3.givenProvider ||
    "wss://eth-mainnet.g.alchemy.com/v2/JfW762LZ_7QB09jBktp4Yii24Jf755uf"
);
